import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { DoctorDashboardService } from './doctor.dashboard.service';
import { FormGroup, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-doctor-dashboard',
  templateUrl: './doctor-dashboard.component.html',
  styleUrls: ['./doctor-dashboard.component.scss']
})
export class DoctorDashboardComponent implements OnInit {
  selected = 'none';
  dataDetail: boolean = true;
  graphDetail: boolean = false;
  datashow1: boolean = true;
  graphshow1: boolean = false;
  datashow2: boolean = true;
  graphshow2: boolean = false;
  datashow3: boolean = true;
  graphshow3: boolean = false;
  datashow4: boolean = true;
  graphshow4: boolean = false;
  datashow5: boolean = true;
  graphshow5: boolean = false;
  datashow6: boolean = true;
  graphshow6: boolean = false;

  sdate: any;
  edate: any;
  scheduleyr: any;
  sugeryyr: any;
  patientratio: any;
  surgeriesdone: any;
  contrctSergery: any;
  surgeriescouncellingRatio: any;
  patientGrowth: any;
  sergeryGrowth:any;
  OpdRevenue:any;
  IpdRevenue:any;
  Settingobject:any;
 
  // public pieCh
  artType: ChartType = 'pie';
  doctorDashboardArray: any = [];
  scheduleAppoitment: any = [];
  scheduleSergery: any = [];
  getRevenueArray: any = [];
  barChartOptions: ChartOptions = {
    responsive: true,
  };
  barChartLabels: Label[];
  barChartType: ChartType = 'bar';
  barChartLegend = false;
  barChartPlugins = [];
  public barChartData:any[] = [ ];

  sbarChartLabels: Label[];
  sbarChartType: ChartType = 'bar';
  sbarChartLegend = true;
  sbarChartPlugins = [];
  public sbarChartData:any[] = [ ];
  sbarChartOptions: ChartOptions = {
    responsive: true,

  };
  opdbarChartLabels: Label[];
  opdbarChartType: ChartType = 'bar';
  opdbarChartLegend = true;
  opdbarChartPlugins = [];
  public opdbarChartData:any[] = [ ];
  opdbarChartOptions: ChartOptions = {
    responsive: true,

  };
  ipdbarChartLabels: Label[];
  ipdbarChartType: ChartType = 'bar';
  ipdbarChartLegend = true;
  ipdbarChartPlugins = [];
  public ipdbarChartData:any[] = [ ]; 
  ipdbarChartOptions: ChartOptions = {
    responsive: true,
  };
  pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'left',
      labels: {
        boxWidth: 10

      }

    },

  };
  pieChartColors = [{
    backgroundColor: ['rgba(255,0,0,0.3)', 'rgba(0,255,0,0.3)'],
  },
  ];
  pieChartLabels: Label[] = ['2021', '2022'];
  pieChartType: ChartType = 'pie';
  pieChartLegend = true;
  pieChartPlugins = [

  ];
  pieChartData: ChartDataSets[] = [
    { data: [45, 37], label: 'No. of Patients' }
  ];

  // range = new FormGroup({
  //   start: new FormControl,
  //   end: new FormControl,
  // });


  constructor(public authService: AuthService, public doctorDahboard: DoctorDashboardService, private datePipe: DatePipe) { 
    this.defaultArray();
  }


  dataDetails() {
    this.dataDetail = true;
    this.graphDetail = false;
  }

  graphDetails() {
    this.dataDetail = false;
    this.graphDetail = true;
  }
  dataShow(check) {

    switch (check) {
      case 1:
        this.datashow1 = true;
        this.graphshow1 = false;
        break;

      case 2:
        this.datashow2 = true;
        this.graphshow2 = false;
        break;
      case 3:
        this.datashow3 = true;
        this.graphshow3 = false;
        break;

      case 4:
        this.datashow4 = true;
        this.graphshow4 = false;
        break;
      case 5:
        this.datashow5 = true;
        this.graphshow5 = false;
        break;

      case 6:
        this.datashow6 = true;
        this.graphshow6 = false;
        break;

    }
  }

  graphShow(check) {
   
    switch (check) {
      case 1:
        this.datashow1 = false;
        this.graphshow1 = true;
        break;
      case 2:
        this.datashow2 = false;
        this.graphshow2 = true;
        break;
      case 3:
        this.datashow3 = false;
        this.graphshow3 = true;
        break;
      case 4:
        this.datashow4 = false;
        this.graphshow4 = true;
        break;
      case 5:
        this.datashow5 = false;
        this.graphshow5 = true;
        break;
      case 6:
        this.datashow6 = false;
        this.graphshow6 = true;
        break;
    }
  }
  
  tablesetting() {
    document.getElementById("FilterSettingModel").style.display = "block";
  }
  tablesettingclose() {
    document.getElementById("FilterSettingModel").style.display = "none";

  }


  ngOnInit(): void {
    
    let fdate = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
    let todate = new Date();
    this.scheduleyr = "WEEK";
    this.sugeryyr = "WEEK";
    this.patientratio = "WEEK";
    this.surgeriesdone = "WEEK";
    this.surgeriescouncellingRatio = "WEEK";
    this.contrctSergery = "WEEK";
    this.patientGrowth = "WEEK";
    this.sergeryGrowth="WEEK";
    this.OpdRevenue="WEEK";
    this.IpdRevenue="WEEK";
    this.getDoctorDetail(todate, this.scheduleyr);
    this.sdate = todate;
    this.getRevenueData(todate ,"OPD");
    this.getRevenueIPDData(todate ,"IPD");
    // this.range.get('start').patchValue(fdate);
    // this.range.get('end').patchValue(todate);
    // this.getAppoitmentSchsuledata(fdate,this.scheduleyr);
    //this.getSchsuleSergery(fdate,this.sugeryyr);
  }
  pushbarchartdata: any = [];
  pushsbarchartdata: any = [];
  getDoctorDetail(fdate: any, type: any) {
    this.pushbarchartdata = [];
    this.pushsbarchartdata = [];
    this.doctorDashboardArray = [];
    this.barChartData = [];
    this.barChartLabels = [];
    this.sbarChartData = [];
    this.sbarChartLabels = [];
    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
    this.doctorDahboard.GetDoctorDashBoardYear(changefdate, this.authService.masterdata.pkUserId, type).subscribe(data => {
      if (data.length > 0) {
        this.doctorDashboardArray = data
        this.barChartLabels.push('WEEK');
        this.pushbarchartdata.push(this.doctorDashboardArray[0]?.curScheduledAppt);
        this.barChartData.push({ data: this.pushbarchartdata, label: 'Scheduled Appointment' });
        this.sbarChartLabels.push('WEEK');
        this.pushsbarchartdata.push(this.doctorDashboardArray[0]?.curBookedSurgery);
        this.sbarChartData.push({ data: this.pushsbarchartdata, label: 'Scheduled Surgeries' });
      }
    });

  }
  // startdateChanged(event) {
  
  //   if (event != null) {
  //     let type = 'WEEK';
  //     this.getDoctorDetail(event, type);
  //     this.getRevenueData(event ,"OPD");
  //     this.getRevenueIPDData(event ,"IPD");
  //   }

  // }
  //  enddateChanged(){
  //   if(this.range.value.start !=null && this.range.value.end !=null){
  //     this.getDoctorDetail(this.range.value.start,this.range.value.end);
  //  }
  //  }

  //schecdule Appoitnment data

  scheduleAppointment(event, checktype) {
   
    switch (checktype) {
      case (1): {
        this.barChartLabels = [];
       
        var fdate = new Date();
        this.barChartLabels.push(event);
        this.getAppoitmentSchsuledata(fdate, event);

        break;
      }
      case (2): {
        this.sbarChartLabels = [];
       
        var fdate = new Date();
        this.sbarChartLabels.push(event);
        this.getSchsuleSergery(fdate, event);
        break;
      }
      case (3): {
        let fdate = new Date();
        this.getPatientRatio(fdate, event);
        break;
      }
      case (4): {
        let fdate = new Date();
        this.getSurgicalDone(fdate, event);
        break;
      }
      case (5): {
        let fdate = new Date();
        this.getSurgicalCounselling(fdate, event);
        break;
      }
      case (6): {
        let fdate = new Date();
        this.getContractSergury(fdate, event);
      }
      case (7): {
        let fdate = new Date();
        this.getPatientGrowth(fdate, event);
      }
      case(8):{
        let fdate=new Date();
        this.getSergeryGrowth(fdate, event);
      }
      case(9):{
        let fdate= new Date();
        this.getOpdRevenue(fdate, event);
      }
      case(10):{
        let fdate= new Date();
        this.getIpdRevenue(fdate, event);
      }
    }

  }

  getAppoitmentSchsuledata(fdate: any, type: any) {
    this.pushbarchartdata = [];
    this.barChartData = [];

    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");

    this.doctorDahboard.GetDoctorDashBoardYear(changefdate, this.authService.masterdata.pkUserId, type).subscribe(data => {
      if (data.length > 0) {

        this.doctorDashboardArray[0]['curScheduledAppt'] = data[0]?.curScheduledAppt ? data[0]?.curScheduledAppt : 0;
        this.doctorDashboardArray[0]['percentScheduledAppt'] = data[0]?.percentScheduledAppt ? data[0]?.percentScheduledAppt : 0;
        this.pushbarchartdata.push(this.doctorDashboardArray[0]['curScheduledAppt']);
        this.barChartData.push({ data: this.pushbarchartdata, label: 'Scheduled Appointment' });
      }
    });
  }

  //Schedule Sergery
  getSchsuleSergery(fdate: any, type: any) {
  
    this.pushsbarchartdata = [];
    this.sbarChartData = [];
    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
    this.doctorDahboard.GetDoctorDashBoardYear(changefdate, this.authService.masterdata.pkUserId, type).subscribe(data => {
      if (data.length > 0) {
        this.doctorDashboardArray[0]['curBookedSurgery'] = data[0]?.curBookedSurgery ? data[0]?.curBookedSurgery : 0;
        this.doctorDashboardArray[0]['percentBookedSurgery'] = data[0]?.percentBookedSurgery ? data[0]?.percentBookedSurgery : 0;

        this.pushsbarchartdata.push(this.doctorDashboardArray[0]['curBookedSurgery']);
        this.sbarChartData.push({ data: this.pushsbarchartdata, label: 'Scheduled Surgeries' });
      }
    });
  }
  //get patient ratio
  getPatientRatio(fdate: any, type: any) {
    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
    this.doctorDahboard.GetDoctorDashBoardYear(changefdate, this.authService.masterdata.pkUserId, type).subscribe(data => {
      if (data.length > 0) {
        this.doctorDashboardArray[0]['curWalkInAppt'] = data[0]?.curWalkInAppt ? data[0]?.curWalkInAppt : 0;
        this.doctorDashboardArray[0]['curWithAppt'] = data[0]?.curWithAppt ? data[0]?.curWalkInAppt : 0;
        this.doctorDashboardArray[0]['percentWithAppt'] = data[0]?.percentWithAppt ? data[0]?.curWalkInAppt : 0;
      }
    });
  }
  // get surgical done
  getSurgicalDone(fdate: any, type: any) {
    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
    this.doctorDahboard.GetDoctorDashBoardYear(changefdate, this.authService.masterdata.pkUserId, type).subscribe(data => {
      if (data.length > 0) {
        this.doctorDashboardArray[0]['curConsDoneSurgery'] = data[0]?.curConsDoneSurgery ? data[0]?.curConsDoneSurgery : 0;
        this.doctorDashboardArray[0]['preConsDoneSurgery'] = data[0]?.preConsDoneSurgery ? data[0]?.preConsDoneSurgery : 0;
        this.doctorDashboardArray[0]['percentConsDoneSurgery'] = data[0]?.percentConsDoneSurgery ? data[0]?.percentConsDoneSurgery : 0;
      }
    });
  }
  // get Surgical Counselling Ratio
  getSurgicalCounselling(fdate: any, type: any) {
    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
    this.doctorDahboard.GetDoctorDashBoardYear(changefdate, this.authService.masterdata.pkUserId, type).subscribe(data => {
      if (data.length > 0) {
        this.doctorDashboardArray[0]['curBookedSurgery'] = data[0]?.curBookedSurgery ? data[0]?.curBookedSurgery : 0;
        this.doctorDashboardArray[0]['preBookedSurgery'] = data[0]?.preBookedSurgery ? data[0]?.preBookedSurgery : 0;
        this.doctorDashboardArray[0]['percentBookedSurgery'] = data[0]?.percentBookedSurgery ? data[0]?.percentBookedSurgery : 0;
      }
    });
  }
  getContractSergury(fdate: any, type: any) {
    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
    this.doctorDahboard.GetDoctorDashBoardYear(changefdate, this.authService.masterdata.pkUserId, type).subscribe(data => {
      if (data.length > 0) {
        this.doctorDashboardArray[0]['curCataract'] = data[0]?.curCataract ? data[0]?.curCataract : 0;
        this.doctorDashboardArray[0]['preCataract'] = data[0]?.preCataract ? data[0]?.preCataract : 0;
        this.doctorDashboardArray[0]['percentCataract'] = data[0]?.percentCataract ? data[0]?.percentCataract : 0;
      }
    });
  }

  getPatientGrowth(fdate: any, type: any) {
    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
    this.doctorDahboard.GetDoctorDashBoardYear(changefdate, this.authService.masterdata.pkUserId, type).subscribe(data => {
      if (data.length > 0) {
        this.doctorDashboardArray[0]['ptGrowth'] = data[0]?.ptGrowth ? data[0]?.ptGrowth : 0;
        this.doctorDashboardArray[0]['ptGrowthPercent'] = data[0]?.ptGrowthPercent ? data[0]?.ptGrowthPercent : 0;
      }
    });
  }

  getSergeryGrowth(fdate: any, type: any){
    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
    this.doctorDahboard.GetDoctorDashBoardYear(changefdate, this.authService.masterdata.pkUserId, type).subscribe(data => {
      if (data.length > 0) {
        this.doctorDashboardArray[0]['surgeryGrowth'] = data[0]?.surgeryGrowth ? data[0]?.surgeryGrowth : 0;
        this.doctorDashboardArray[0]['surgeryGrowthPercent'] = data[0]?.surgeryGrowthPercent ? data[0]?.surgeryGrowthPercent : 0;
      }
    });
  }
  getOpdRevenue(fdate: any, type: any){
    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
    this.doctorDahboard.GetDoctorDashBoardYear(changefdate, this.authService.masterdata.pkUserId, type).subscribe(data => {
      if (data.length > 0) {
        this.doctorDashboardArray[0]['curOpdAmt'] = data[0]?.curOpdAmt ? data[0]?.curOpdAmt : 0;
        this.doctorDashboardArray[0]['percentOpdAmt'] = data[0]?.percentOpdAmt ? data[0]?.percentOpdAmt : 0;
      }
    });
  }
  getIpdRevenue(fdate: any, type){
    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
    this.doctorDahboard.GetDoctorDashBoardYear(changefdate, this.authService.masterdata.pkUserId, type).subscribe(data => {
      if (data.length > 0) {
        this.doctorDashboardArray[0]['curIpdAmt'] = data[0]?.curIpdAmt ? data[0]?.curIpdAmt : 0;
        this.doctorDashboardArray[0]['percentIpdAmt'] = data[0]?.percentIpdAmt ? data[0]?.percentIpdAmt : 0;
      }
    });
  }
  // get opd revenue
  pushopdbarchartdata:any[]=[];
  getipddata:any=[];
  getRevenueData(fdate: any, type) {
    this.pushopdbarchartdata=[];
    this.opdbarChartLabels =[];
    this.opdbarChartData=[];
    this.getipddata =[];
    let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
    try {

      this.doctorDahboard.GetDoctorDashBoardGraph(changefdate, this.authService.masterdata.pkUserId, type).subscribe( // this.api is my api service and getAPI is present there
        (data: any) => {
          if (data == null) {
            throw 'Empty response';
          } else {
            this.getipddata =data;
            this.getipddata.forEach(element => { 
             this.pushopdbarchartdata.push( element.amount);
             this.opdbarChartLabels.push(element.monthName);
            });
            console.log(this.pushopdbarchartdata);
        this.opdbarChartData=[{ data: this.pushopdbarchartdata, label: 'Growth in OPD Revenue' }];
          }
        },
        (error: HttpErrorResponse) => {
          console.log(error);
        });

    } catch (e) {
      console.log(e);
    }

  }
 
   // get opd revenue
   pushipdbarchartdata:any=[];
   getIdpdata:any=[];
   getRevenueIPDData(fdate: any, type) {
     this.pushipdbarchartdata=[];
     this.ipdbarChartLabels =[];
     this.ipdbarChartData=[];
     this.getIdpdata=[];
     let changefdate = this.datePipe.transform(fdate, "MMM-d-y");
     try {
 
       this.doctorDahboard.GetDoctorDashBoardGraph(changefdate, this.authService.masterdata.pkUserId, type).subscribe( // this.api is my api service and getAPI is present there
         (data: any) => {
           if (data == null) {
             throw 'Empty response';
           } else {
            this.getIdpdata =data;
            this.getIdpdata.forEach(element => {
              this.pushipdbarchartdata.push(element.amount);
               this.ipdbarChartLabels.push(element.monthName);
             });
         
         this.ipdbarChartData.push({ data:  this.pushipdbarchartdata, label: 'Growth in IPD Revenue' });
           }
         },
         (error: HttpErrorResponse) => {
           console.log(error);
         });
 
     } catch (e) {
       console.log(e);
     }
 
   }

   
  calculateRatio(num_1, num_2) {

    for (var num = num_2; num > 1; num--) {

      if ((num_1 % num) == 0 && (num_2 % num) == 0) {
        num_1 = num_1 / num;
        num_2 = num_2 / num;
      }

    }
    var ratio = num_1 + ":" + num_2;
    return ratio;
  }
  checklistdata:any=[];
  isAllSelected(status,id){
    this.checklistdata=[];
    this.checklistdata=this.Settingobject;
    if(status ==true){
      this.checklistdata[id].status = false;
    }else{
      this.checklistdata[id].status = true;
    }
    this.Settingobject= this.checklistdata;
  }
   
  defaultArray(){
    this.Settingobject=[{
      id:1, lebel:"Scheduled Appointments",status:true},
      {
       id:2, lebel:"Total OPD Patients",status:true
      },
      {
       id:3, lebel:"Total Surgeries",status:true
      },
      {
       id:4, lebel:"Scheduled Surgeries",status:true
      },
      {
       id:5, lebel:"Patient Seen",status:true
      },
      {
       id:6, lebel:"Patient Ratio",status:true
      },
      {
       id:7, lebel:"Surgeries Done",status:true
      },
      {
       id:8, lebel:"Surgical Counselling Ratio",status:true
      },
      
      {
       id:9, lebel:"Cataract Surgery",status:true
      },
      {
       id:10, lebel:"Growth in Patients",status:true
      },
      {
       id:11, lebel:"Growth in Surgeries",status:true
      },
      {
       id:12, lebel:"Data to be added",status:true
      },
      {
       id:13, lebel:"OPD Revenue",status:true
      },
      {
       id:14, lebel:"Growth in OPDRevenue",status:true
      },
      {
       id:15, lebel:"IPD Revenue",status:true
      },
      {
       id:16, lebel:"Growth in IPDRevenue",status:true
      }];
  }
}
